import { render, staticRenderFns } from "./OzBaseButton.vue?vue&type=template&id=1ad608eb&"
import script from "./OzBaseButton.vue?vue&type=script&lang=ts&"
export * from "./OzBaseButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./OzBaseButton.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports